/**
 * @constant {string} AFTER
 */
export var AFTER = 'after';

/**
 * @constant {string} AFTER_PRINT
 */
export var AFTER_PRINT = 'afterprint';

/**
 * @constant {string} BEFORE
 */
export var BEFORE = 'before';

/**
 * @constant {string} BEFORE_PRINT
 */
export var BEFORE_PRINT = 'beforeprint';

/**
 * @constant {Object} GLOBAL_VALUES
 */
export var GLOBAL_VALUES = {
  createNewEvent: null,
  hasMatchMediaSupport: false,
  hasNewErrorSupport: false,
  hasOnAfterPrintSupport: false,
  hasOnBeforePrintSupport: false,
  hasPrintEventSupport: false,
  isInitialized: false,
  mql: null
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/printscout/es/constants.js
// module id = 167
// module chunks = 0